module.exports = __webpack_public_path__ + "img/tamperproofImg.b4054332.png";